// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'
// views
import { StyledMaterialAvatar } from 'components/UI/Avatar'
import { ActivityActionsWrapper } from 'components/Modals/PlanItems/components/ActivitiesList/components/Activities/components/ActionBar/views'

const Data = styled('div')`
  width: 100%;
  min-width: 0;
  position: relative;
`

const Wrapper = styled('div')`
  display: flex;
  margin-bottom: 16px;
  width: inherit;

  ${StyledMaterialAvatar} {
    margin-right: 10px;
  }

  &:hover {
    ${ActivityActionsWrapper} {
      display: flex;
    }
  }
`

const DateWrapper = styled('div')`
  font-size: 12px;
  color: ${colors.gray300};
  margin-left: 6px;
  font-weight: normal;
`

const Content = styled('div')`
  display: flex;
  flex-direction: column;

  > p {
    margin: 0;
  }

  * {
    font-family: inherit !important;
  }
`

const Link = styled('a')`
  color: ${colors.black};
`

const AuthorInfo = styled('div')`
  font-weight: bold;
  display: flex;
  align-items: baseline;
  margin-top: 10px;
`

const ActivityComponent = styled('img')`
  max-width: 100%;
  border-radius: 6px;
  margin-top: 10px;
  width: fit-content;
`

export { Data, Wrapper, DateWrapper, Content, AuthorInfo, ActivityComponent, Link }
